import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import {
  CustomSelect, IntInput
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import ImageList from "@mui/material/ImageList";
import { hardwareData } from "variables/MBM/lists/equipments";
import { controltypeData, controllistData } from "variables/MBM/lists/equipments";
import uuid from "react-uuid";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";

import { postSchedule, putSchedule, getMBMAVOBBoxs, getLinkedCalendars } from "services/ConfigServices";
import styled from "styled-components";

import { typeData, lightStateData, destinationData } from "variables/MBM/lists/schedule";
import DefaultWeekEventDialog from "./DefaultWeekEventDialog";
import CalendarEventDialog from "./CalendarEventDialog";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid' // a plugin!
import frLocale from '@fullcalendar/core/locales/fr';
import interactionPlugin from '@fullcalendar/interaction'; // for selectable
import "./schedules.css";
import CustomConfirmationDialog from "components/CustomDialog/CustomConfirmationDialog";
import { scheduletext } from "variables/MBM/schedule";
import AutocompleteMultiselectInputById from "components/Input/AutocompleteMultiselectInputById.js";
import { isNumber } from "lodash";


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);

function ScheduleDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const { closeModal, refetch, setLoading, setNotification, currentSchedule, wpgroup, equipmentsdata, pointsdata } = props;
  const [openDefaultWeekEvent, setOpenDefaultWeekEvent] = useState(false);
  const [openCalendarEvent, setOpenCalendarEvent] = useState(false);
  const [type, setType] = useState(currentSchedule?.parameters?.type || "light");
  const [equipmenttype, setEquipmenttype] = useState(currentSchedule?.parameters?.equipmenttype || "");
  const [controltype, setControltype] = useState(currentSchedule?.parameters?.controltype || "");
  const [typetoconfirm, setTypetoconfirm] = useState("");
  const [typechangeopen, setTypechangeopen] = useState(false);
  const [equipmenttypetoconfirm, setEquipmenttypetoconfirm] = useState("");
  const [equipmenttypechangeopen, setEquipmenttypechangeopen] = useState(false);
  const [controltypetoconfirm, setControltypetoconfirm] = useState("");
  const [controltypechangeopen, setControltypechangeopen] = useState(false);
  const [name, setName] = useState(currentSchedule?.parameters?.name || "");
  const [description, setDescription] = useState(currentSchedule?.parameters?.description || "");
  const [destinationtype, setDestinationtype] = useState(currentSchedule?.destination?.destinationtype || "avobbox");
  const [avobboxs, setAvobboxs] = useState(currentSchedule?.destination?.avobboxs || []);
  //const [groups, setGroups] = useState(currentSchedule?.groupid ? "" + currentSchedule.groupid : ""); 
  const [groups, setGroups] = useState(currentSchedule?.groupid ? "" + currentSchedule.groupid : "" + wpgroup);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [linkedcalendar, setLinkedCalendar] = useState(currentSchedule?.parameters?.linkedcalendar || -1);
  const [timebeforeevent, setTimebeforeevent] = useState(currentSchedule?.parameters?.timebeforeevent || 0);
  const [timeafterevent, setTimeafterevent] = useState(currentSchedule?.parameters?.timeafterevent || 0);
  const [eventvalue, setEventvalue] = useState(currentSchedule?.parameters?.eventvalue || "");
  const [eventcontrolid, setEventcontrolid] = useState(currentSchedule?.parameters?.eventcontrolid || "");
  const [outeventvalue, setOuteventvalue] = useState(currentSchedule?.parameters?.outeventvalue || "");
  const [outeventcontrolid, setOuteventcontrolid] = useState(currentSchedule?.parameters?.outeventcontrolid || "");
  const [dontapplyinevent, setDontapplyinevent] = useState(currentSchedule?.parameters?.dontapplyinevent || false);
  const [lightStateDataForevent, setlightStateDataForevent] = useState([]);
  const [availablemodesForevent, setAvailablemodesForevent] = useState([]);

  const [filteredHardwareData, setFilteredHardwareData] = useState(hardwareData);

  const [availablecontroltype, setAvailablecontroltype] = useState([]);
  const [availablemodes, setAvailablemodes] = useState([]);
  const [boxdata, setBoxdata] = useState([]);
  const [linkedCalendarsdata, setLinkedCalendarsdata] = useState([]);

  const [editedevent, setEditedevent] = useState("");

  const [defaultweekevents, setDefaultweekevents] = useState(currentSchedule?.defaultweekevents || []);
  const [defaultweekeventsdisplay, setDefaultweekeventsdisplay] = useState([]);
  const [calendarevents, setCalendarevents] = useState(currentSchedule?.calendarevents || []);
  const [calendareventsdisplay, setCalendareventsdisplay] = useState([]);

  useEffect(() => {
    let tmplightStateDataForevent = [...lightStateData];
    tmplightStateDataForevent.unshift({ id: "novalue", name: scheduletext.novalue });
    setlightStateDataForevent(tmplightStateDataForevent);
  }, []);

  useEffect(() => {
    let tmphardwaredata = hardwareData.filter((hw) =>
      equipmentsdata?.some((eq) => eq.otherproperties?.hardware && eq.otherproperties.hardware === hw.id)
    );
    setFilteredHardwareData(tmphardwaredata);
  }, [equipmentsdata]);

  useEffect(() => {
    let targetequipments = equipmentsdata?.filter((eq) =>
      eq.otherproperties?.hardware === equipmenttype);
    let availablecontroltypetmp = [];
    let firsteq = true;
    targetequipments?.forEach((eq) => {
      let eqpoints = pointsdata.filter((p) => p.equipment == eq.id && p.controlproperties?.controltype);
      if (firsteq) {
        availablecontroltypetmp = eqpoints.map((pt) => pt.controlproperties.controltype);
        firsteq = false;
      }
      else {
        availablecontroltypetmp = availablecontroltypetmp.filter((controltype) =>
          eqpoints.some((pt) => pt.controlproperties.controltype == controltype));
      }
    }
    );
    let availablecontroltypelist = controltypeData.filter((controltype) => availablecontroltypetmp.some((controltypeid) => controltypeid == controltype.id));
    setAvailablecontroltype(availablecontroltypelist);
  }, [equipmenttype, equipmentsdata, pointsdata]);

  useEffect(() => {
    let availablemodestmp = [];
    let controltypedef = controltypeData.find((ctrl) => ctrl.id === controltype);
    if (controltypedef && controltypedef.type === 'list') {
      let pointstofilter = [];
      let multiplepointsbyeq = false;
      let firstpt = true;
      let targetequipments = equipmentsdata?.filter((eq) =>
        eq.otherproperties?.hardware === equipmenttype);
      targetequipments?.forEach((eq) => {
        let eqpoints = pointsdata.filter((p) => p.equipment == eq.id && p.controlproperties?.controls && p.controlproperties.controltype === controltype);
        pointstofilter = pointstofilter.concat(eqpoints);
        if (eqpoints.length > 1)
          multiplepointsbyeq = true;
        eqpoints.forEach((pt) => {
          if (firstpt) {
            availablemodestmp = [...pt.controlproperties.controls];
            firstpt = false;
          }
          else {
            let newavailablemodes = [...pt.controlproperties.controls];
            availablemodestmp = availablemodestmp.filter((mode) =>
              newavailablemodes.some((newmode) => mode.id === newmode.id));
          }
        });
      });
    }
    availablemodestmp.forEach((mode) => {
      mode.name = controllistData.find((cl) => cl.id === mode.id)?.name || "Mode non reconnu";
    });
    // availablemodestmp.forEach((mode) => {
    //   mode.id = Number(mode.val);
    // });
    setAvailablemodes(availablemodestmp);
    let availablemodesforeventtmp = [...availablemodestmp];
    availablemodesforeventtmp.unshift({ id: "novalue", val: "novalue", name: scheduletext.novalue });
    setAvailablemodesForevent(availablemodesforeventtmp);
  }, [equipmenttype, equipmentsdata, pointsdata, controltype]);

  const handleTypeChange = (event) => {
    if (defaultweekevents.length > 0 || calendarevents.length > 0) {
      setTypetoconfirm(event.target.value);
      setTypechangeopen(true);
    }
    else {
      setType(event.target.value);
    }
  };
  const handleEquipmenttypeChange = (event) => {
    if (defaultweekevents.length > 0 || calendarevents.length > 0) {
      setEquipmenttypetoconfirm(event.target.value);
      setEquipmenttypechangeopen(true);
    }
    else {
      setEquipmenttype(event.target.value);
    }
  }
  const handleControltypeChange = (event) => {
    if (defaultweekevents.length > 0 || calendarevents.length > 0) {
      setControltypetoconfirm(event.target.value);
      setControltypechangeopen(true);
    }
    else {
      setControltype(event.target.value);
    }
  }
  const applyChangeType = () => {
    setTypechangeopen(false);
    setDefaultweekevents([]);
    setCalendarevents([]);
    setType(typetoconfirm);
    setTypetoconfirm("");
  }
  const denyChangeType = () => {
    setTypechangeopen(false);
    setTypetoconfirm("");
  }
  const applyChangeEquipmentType = () => {
    setEquipmenttypechangeopen(false);
    setDefaultweekevents([]);
    setCalendarevents([]);
    setEquipmenttype(equipmenttypetoconfirm);
    setEquipmenttypetoconfirm("");
  }
  const denyChangeEquipmentType = () => {
    setEquipmenttypechangeopen(false);
    setEquipmenttypetoconfirm("");
  }
  const applyChangeControlType = () => {
    setControltypechangeopen(false);
    setDefaultweekevents([]);
    setCalendarevents([]);
    setControltype(controltypetoconfirm);
    setControltypetoconfirm("");
  }
  const denyChangeControlType = () => {
    setControltypechangeopen(false);
    setControltypetoconfirm("");
  }


  const handleNameChange = (event) => { setName(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const handleDestinationtypeChange = (event) => {
    setDestinationtype(event.target.value);
  };
  const selectedBox = () => {
    let selected = boxdata.filter((obj) =>
      avobboxs.includes(obj.id));
    return selected;
  };
  const handleBoxsChange = (selected) => {
    let newArray = [];
    for (let i = 0; i < selected.length; i++) {
      newArray.push(selected[i].id);
    }
    setAvobboxs(newArray);
  };

  const handleLinkedCalendarChange = (event) => { setLinkedCalendar(event.target.value); };
  const handleTimebeforeeventChange = (event) => { setTimebeforeevent(event.target.value); };
  const handleTimeaftereventChange = (event) => { setTimeafterevent(event.target.value); };
  const handleDontapplyineventChange = (event) => {
    setDontapplyinevent(!dontapplyinevent);
  };
  const handleEventvalueChange = (event) => {
    if (type === "temperature") {
      if (event.target.value < 0 || event.target.value > 100)
        return;
      setEventvalue(event.target.value);
    }
    else if (type === "equipment") {
      if (controltypeData.find((c) => c.id === controltype).type === 'list') {
        let mode = availablemodesForevent.find((m) => m.id === event.target.value);
        setEventvalue(isNumber(mode.val) ? Number(mode.val) : mode.val);
        setEventcontrolid(mode.id);
      }
      else
        setEventvalue(event.target.value);
    }
    else
      setEventvalue(event.target.value);
  };
  const handleOuteventvalueChange = (event) => {
    if (type === "temperature") {
      if (event.target.value < 0 || event.target.value > 100)
        return;
      setOuteventvalue(event.target.value);
    }
    else if (type === "equipment") {
      if (controltypeData.find((c) => c.id === controltype).type === 'list') {
        let mode = availablemodesForevent.find((m) => m.id === event.target.value);
        setOuteventvalue(isNumber(mode.val) ? Number(mode.val) : mode.val);
        setOuteventcontrolid(mode.id);
      }
      else
        setOuteventvalue(event.target.value);
    }
    else
      setOuteventvalue(event.target.value);
  };

  const classes = useStyles();
  const [value, setValue] = useState("0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickOpenDefaultWeekEvent = () => {
    setOpenDefaultWeekEvent(true);
  };
  const handleEditCloseDefaultWeekEvent = () => {
    setOpenDefaultWeekEvent(false);
  };
  const handleClickOpenCalendarEvent = () => {
    setOpenCalendarEvent(true);
  };
  const handleEditCloseCalendarEvent = () => {
    setOpenCalendarEvent(false);
  };


  const handleSubmit = (event) => {
    if (currentSchedule)
      updateSchedule(event);
    else
      createSchedule(event);
    //setLoading(true);
    closeModal();
  };

  useEffect(() => {
    if (!name || !groups || groups.length === 0)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  useEffect(() => {
    if (groups) {
      axios
        .get(
          getMBMAVOBBoxs(groups),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let filteredavobboxs = res.data.avobboxs?.filter((obj) => obj.type === 3);
          let tmpBoxsData = filteredavobboxs.map((data) => {
            return (
              { name: data.name, id: data.id }
            );
          });
          setBoxdata(tmpBoxsData || []);
        });

      axios
        .get(
          getLinkedCalendars(groups),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmplinkedcalendarsData = res.data.linkedcalendars?.map((data) => {
            return (
              { name: data.parameters?.name, id: data.id }
            );
          });
          tmplinkedcalendarsData.unshift({ name: scheduletext.none, id: -1 })
          setLinkedCalendarsdata(tmplinkedcalendarsData || []);
        });
    }
  }, [groups]);

  //default week calendar display
  useEffect(() => {
    const tmpdisplayevents = defaultweekevents.map((event) => {
      let displayedevent = {};
      displayedevent.id = event.id;
      if (type === "light") {
        displayedevent.title = event.name + " (" + lightStateData.find((x) => x.id == event.value)?.name + ")";
        displayedevent.color = lightStateData.find((x) => x.id == event.value)?.color;
        displayedevent.textColor = lightStateData.find((x) => x.id == event.value)?.textColor;
      }
      else if (type === "temperature") {
        displayedevent.title = event.name + " (" + event.value + " °C)";
        if (event.value < 24) {
          displayedevent.textColor = "#000000";
          if (event.value < 10)
            displayedevent.color = "#DEECFF";
          else if (event.value < 16)
            displayedevent.color = "#85ABFF";
          else if (event.value < 18)
            displayedevent.color = "#00DFD7";
          else if (event.value < 20)
            displayedevent.color = "#10D081";
          else if (event.value < 22)
            displayedevent.color = "#E5EB85";
          else
            displayedevent.color = "#FF6B54";
        }
        else {
          displayedevent.textColor = "#FFFFFF";
          displayedevent.color = "#FF6B54";
        }
      }
      else if (type === "equipment") {
        if (controltypeData.find((c) => c.id === controltype).type === 'int') {
          displayedevent.title = event.name + " (" + event.value + " " + controltypeData.find((c) => c.id === controltype).unit + ")";
        }
        else if (controltypeData.find((c) => c.id === controltype).type === 'list') {
          displayedevent.title = event.name + " (" + availablemodes.find((m) => m.id === event.controlid)?.name + ")";
        }
      }
      else
        displayedevent.title = event.name + " (" + event.value + ")";
      let nowdate = moment();
      let timearray = event.startTime.split(':');
      let hours = Number(timearray[0]);
      let minutes = Number(timearray[1]);
      nowdate.set('day', event.startDay);
      nowdate.set('hour', hours);
      nowdate.set('minute', minutes);
      nowdate.set('second', 0);
      if (event.startDay === 0)
        nowdate.add(7, 'day');
      displayedevent.start = nowdate.format("YYYY-MM-DD HH:mm:ss");

      nowdate = moment();
      timearray = event.endTime.split(':');
      hours = Number(timearray[0]);
      minutes = Number(timearray[1]);
      nowdate.set('day', event.endDay);
      nowdate.set('hour', hours);
      nowdate.set('minute', minutes);
      nowdate.set('second', 0);
      if (event.endDay === 0)
        nowdate.add(7, 'day');
      displayedevent.end = nowdate.format("YYYY-MM-DD HH:mm:ss");
      return displayedevent;
    });
    setDefaultweekeventsdisplay(tmpdisplayevents);
  }, [defaultweekevents, defaultweekevents.length, openDefaultWeekEvent, availablemodes]);

  //default exception calendar display
  useEffect(() => {
    const tmpdisplayevents = calendarevents.map((event) => {
      let displayedevent = {};
      displayedevent.id = event.id;
      if (type === "light") {
        displayedevent.title = event.name + " (" + lightStateData.find((x) => x.id == event.value)?.name + ")";
        displayedevent.color = lightStateData.find((x) => x.id == event.value)?.color;
        displayedevent.textColor = lightStateData.find((x) => x.id == event.value)?.textColor;
      }
      else if (type === "temperature") {
        displayedevent.title = event.name + " (" + event.value + " °C)";
        if (event.value < 24) {
          displayedevent.textColor = "#000000";
          if (event.value < 10)
            displayedevent.color = "#DEECFF";
          else if (event.value < 16)
            displayedevent.color = "#85ABFF";
          else if (event.value < 18)
            displayedevent.color = "#00DFD7";
          else if (event.value < 20)
            displayedevent.color = "#10D081";
          else if (event.value < 22)
            displayedevent.color = "#E5EB85";
          else
            displayedevent.color = "#FF6B54";
        }
        else {
          displayedevent.textColor = "#FFFFFF";
          displayedevent.color = "#FF6B54";
        }
      }
      else if (type === "equipment") {
        if (controltypeData.find((c) => c.id === controltype).type === 'int') {
          displayedevent.title = event.name + " (" + event.value + " " + controltypeData.find((c) => c.id === controltype).unit + ")";
        }
        else if (controltypeData.find((c) => c.id === controltype).type === 'list') {
          displayedevent.title = event.name + " (" + availablemodes.find((m) => m.id === event.controlid)?.name + ")";
        }
      }
      else
        displayedevent.title = event.name + " (" + event.value + ")";
      displayedevent.start = event.startDay + " " + event.startTime + ":00";
      displayedevent.end = event.endDay + " " + event.endTime + ":00";
      return displayedevent;
    });
    setCalendareventsdisplay(tmpdisplayevents);
  }, [calendarevents, calendarevents.length, openCalendarEvent]);

  const timeformat = (hours, minute) => {
    let formated = new Intl.NumberFormat('fr-FR', { minimumIntegerDigits: 2 }).format(hours);
    formated += ":";
    formated += new Intl.NumberFormat('fr-FR', { minimumIntegerDigits: 2 }).format(minute);
    return formated;
  }
  const handleSelectTimeDefaultWeek = (event) => {
    let newevent = {};
    newevent.name = "";
    newevent.startDay = event.start.getDay();
    newevent.endDay = event.end.getDay();
    newevent.startTime = timeformat(event.start.getHours(), event.start.getMinutes());
    newevent.endTime = timeformat(event.end.getHours(), event.end.getMinutes());
    newevent.value = "";
    setEditedevent(newevent);
    handleClickOpenDefaultWeekEvent();
  }
  const handleSelectEventDefaultWeek = (event) => {
    let editedevent = defaultweekevents.find((o) => o.id === event.event.id);
    setEditedevent({ ...editedevent });
    handleClickOpenDefaultWeekEvent();
  }
  const handleSelectTimeCalendar = (event) => {
    let startdatestr = event.startStr;
    if (startdatestr.includes("T"))
      startdatestr = startdatestr.substring(0, startdatestr.indexOf("T"));
    let enddatestr = event.endStr;
    if (enddatestr.includes("T"))
      enddatestr = enddatestr.substring(0, enddatestr.indexOf("T"));

    let newevent = {};
    newevent.name = "";
    newevent.startDay = startdatestr;
    newevent.endDay = enddatestr;
    newevent.startTime = timeformat(event.start.getHours(), event.start.getMinutes());
    newevent.endTime = timeformat(event.end.getHours(), event.end.getMinutes());
    newevent.value = "";
    setEditedevent(newevent);
    handleClickOpenCalendarEvent();
  }
  const handleSelectEventCalendar = (event) => {
    let editedevent = calendarevents.find((o) => o.id === event.event.id);
    setEditedevent({ ...editedevent });
    handleClickOpenCalendarEvent();
  }

  const createSchedule = async (event) => {
    const parameters = {
      name,
      type,
      equipmenttype,
      controltype,
      description,
      linkedcalendar,
      timebeforeevent,
      timeafterevent,
      dontapplyinevent,
      eventvalue,
      eventcontrolid,
      outeventvalue,
      outeventcontrolid
    }
    const destination = {
      destinationtype,
      avobboxs,
      avobboxsupdate: avobboxs,
    }
    axios
      .post(
        postSchedule(),
        {
          parameters,
          groups,
          defaultweekevents,
          calendarevents,
          destination,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Planning créée");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const updateSchedule = async (event) => {
    const parameters = {
      ...currentSchedule.parameters,
      name,
      type,
      equipmenttype,
      controltype,
      description,
      linkedcalendar,
      timebeforeevent,
      timeafterevent,
      dontapplyinevent,
      eventvalue,
      eventcontrolid,
      outeventvalue,
      outeventcontrolid
    }
    const destination = {
      ...currentSchedule.destination,
      destinationtype,
      avobboxs,
      avobboxsupdate: avobboxs,
    }
    axios
      .put(
        putSchedule(currentSchedule.id),
        {
          parameters,
          groups,
          defaultweekevents,
          calendarevents,
          destination,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Planning modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  return (
    <>
      <TabContext value={value} className={classes.root}>
        <div className={classes.demo2}>
          <AppBar
            position="static"
            className={classes.demo3}
            style={{ boxShadow: "none", shadowColor: "red" }}
          >
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="styled tabs example"
              scrollButtons="auto"
            >
              <StyledTab label="Paramètres généraux" value="0" />
              <StyledTab label="Planning hebdomadaire" value="1" />
              <StyledTab label="Calendrier d'exceptions" value="2" />
              {
                linkedcalendar > 0 ?
                  <StyledTab label="Règles de l'agenda lié" value="3" /> : <></>
              }

              {/* <StyledTab label="Dérogations" value="3" /> */}

            </StyledTabs>
            <Typography className={classes.padding} />
          </AppBar>
          <Divider variant="fullWidth" />
          <TabPanel value="0">
            <form className={classes.root}>
              <GridContainer>
                {/* <GridItem xs={12} sm={6} md={7} lg={7}>  a reactiver si on pense avoir à choisir le groupe d'un planning au sein d'un workspace */}
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <div>
                    <CustomSelect
                      inputTitle={scheduletext.type}
                      selectValue={type}
                      handleSelectValueChange={handleTypeChange}
                      data={typeData}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  {
                    type === 'equipment' ?
                      <><div>
                        <CustomSelect
                          inputTitle={scheduletext.equipmenttype}
                          selectValue={equipmenttype}
                          handleSelectValueChange={handleEquipmenttypeChange}
                          data={filteredHardwareData}
                          isRequired
                        />
                      </div>
                        <div>
                          <CustomSelect
                            inputTitle={scheduletext.controltype}
                            selectValue={controltype}
                            handleSelectValueChange={handleControltypeChange}
                            data={availablecontroltype}
                            isRequired
                          />
                        </div></>
                      : <></>
                  }

                  <div>
                    <TextInput
                      inputTitle={scheduletext.name}
                      textInput={name}
                      handleTextInputChange={handleNameChange}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={scheduletext.description}
                      textInput={description}
                      handleTextInputChange={handleDescriptionChange}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  <div>
                    <CustomSelect
                      inputTitle={scheduletext.destination}
                      selectValue={destinationtype}
                      handleSelectValueChange={handleDestinationtypeChange}
                      data={destinationData}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  {
                    destinationtype === 'avobbox' ?
                      <div>
                        <AutocompleteMultiselectInputById
                          specialWidth={"97%"}
                          inputMargin={"1rem 0rem 0rem"}
                          inputTitle={scheduletext.concernedavobbox}
                          selected={selectedBox()}
                          list={boxdata}
                          handleChange={handleBoxsChange}
                          disabled={!mbm_geb_control_schedules}
                        />
                      </div> : <></>
                  }

                  <div>
                    <CustomSelect
                      inputTitle={scheduletext.linkedcalendar}
                      selectValue={linkedcalendar}
                      handleSelectValueChange={handleLinkedCalendarChange}
                      data={linkedCalendarsdata}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                </GridItem>
                {/* <GridItem xs={12} sm={6} md={5} lg={5}> //a reactiver si on pense avoir à choisir le groupe d'un planning au sein d'un workspace
                  <div
                    className={classes.treeVisible}
                  >
                    <TreeLabel>Choix du périmètre</TreeLabel>
                    <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                      <EmbeddedEntitesTree
                        selectedIds={setGroups}
                        userSelectedIds={groups}
                        disabled={!mbm_geb_control_schedules}
                      />
                    </ImageList>
                  </div>
                </GridItem> */}
              </GridContainer>
            </form>
          </TabPanel>
          <TabPanel value="1">
            <FullCalendar
              plugins={[timeGridPlugin, interactionPlugin]}
              locales={[frLocale]}
              locale='fr'
              initialView="timeGridWeek"
              height="60vh"
              selectable={mbm_geb_control_schedules}
              scrollTimeReset={false}
              select={handleSelectTimeDefaultWeek}
              eventClick={handleSelectEventDefaultWeek}
              dayHeaderFormat={{
                weekday: 'long'
              }}
              headerToolbar={false}
              views={{
                timeGrid: {
                  allDaySlot: false
                }
              }}
              events={defaultweekeventsdisplay}
            />
          </TabPanel>
          <TabPanel value="2">
            <FullCalendar
              plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
              locales={[frLocale]}
              locale='fr'
              height="60vh"
              selectable={mbm_geb_control_schedules}
              scrollTimeReset={false}
              initialView="dayGridMonth"
              headerToolbar={{
                start: 'today prev,next',
                center: 'title',
                end: 'dayGridMonth timeGridWeek'
              }}
              select={handleSelectTimeCalendar}
              eventClick={handleSelectEventCalendar}
              views={{
                timeGrid: {
                  allDaySlot: false
                }
              }}
              events={calendareventsdisplay}
            />
          </TabPanel>
          <TabPanel value="3">
            <div>
              <IntInput
                inputTitle={scheduletext.timebeforeevent}
                intInput={timebeforeevent}
                handleIntInputChange={handleTimebeforeeventChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
            <div>
              <CustomSwitch
                style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                inputTitle={scheduletext.dontapplyinevent}
                checkedState={dontapplyinevent}
                handleSwitchChange={handleDontapplyineventChange}
                disabled={!mbm_geb_control_schedules || !timebeforeevent}
              />
            </div>
            <div>
              <IntInput
                inputTitle={scheduletext.timeafterevent}
                intInput={timeafterevent}
                handleIntInputChange={handleTimeaftereventChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
            {
              type === "light" ?
                <>
                  <div>
                    <CustomSelect
                      inputTitle={scheduletext.eventvalue}
                      selectValue={eventvalue}
                      handleSelectValueChange={handleEventvalueChange}
                      data={lightStateDataForevent}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                  <div>
                    <CustomSelect
                      inputTitle={scheduletext.outeventvalue}
                      selectValue={outeventvalue}
                      handleSelectValueChange={handleOuteventvalueChange}
                      data={lightStateDataForevent}
                      disabled={!mbm_geb_control_schedules}
                    />
                  </div>
                </>
                : type === "temperature" ?
                  <>
                    <div>
                      <IntInput
                        inputTitle={scheduletext.eventvalue + ' (°C)'}
                        max={100}
                        intInput={eventvalue}
                        handleIntInputChange={handleEventvalueChange}
                        disabled={!mbm_geb_control_schedules}
                      />
                    </div>
                    <div>
                      <IntInput
                        inputTitle={scheduletext.outeventvalue + ' (°C)'}
                        max={100}
                        intInput={outeventvalue}
                        handleIntInputChange={handleOuteventvalueChange}
                        disabled={!mbm_geb_control_schedules}
                      />
                    </div>
                  </>
                  : type === "equipment" ?
                    <>
                      {
                        controltype && controltypeData.find((c) => c.id === controltype) ?
                          (controltypeData.find((c) => c.id === controltype).type === 'int' ?
                            <>
                              <div>
                                <IntInput
                                  inputTitle={scheduletext.eventvalue + " (" + controltypeData.find((c) => c.id === controltype).unit + ")"}
                                  max={100}
                                  intInput={eventvalue}
                                  handleIntInputChange={handleEventvalueChange}
                                  disabled={!mbm_geb_control_schedules}
                                />
                              </div>
                              <div>
                                <IntInput
                                  inputTitle={scheduletext.outeventvalue + " (" + controltypeData.find((c) => c.id === controltype).unit + ")"}
                                  max={100}
                                  intInput={outeventvalue}
                                  handleIntInputChange={handleOuteventvalueChange}
                                  disabled={!mbm_geb_control_schedules}
                                />
                              </div>
                            </> : controltypeData.find((c) => c.id === controltype).type === 'list' ?
                              <>
                                <div>
                                  <CustomSelect
                                    inputTitle={scheduletext.eventvalue}
                                    selectValue={eventcontrolid}
                                    handleSelectValueChange={handleEventvalueChange}
                                    data={availablemodesForevent}
                                    disabled={!mbm_geb_control_schedules}
                                  />
                                </div>
                                <div>
                                  <CustomSelect
                                    inputTitle={scheduletext.outeventvalue}
                                    selectValue={outeventcontrolid}
                                    handleSelectValueChange={handleOuteventvalueChange}
                                    data={availablemodesForevent}
                                    disabled={!mbm_geb_control_schedules}
                                  />
                                </div>
                              </>
                              : <></>
                          ) : <></>
                      }
                    </>
                    :
                    <>
                      <div>
                        <TextInput
                          inputTitle={scheduletext.eventvalue}
                          textInput={eventvalue}
                          handleTextInputChange={handleEventvalueChange}
                          disabled={!mbm_geb_control_schedules}
                        />
                      </div>
                      <div>
                        <TextInput
                          inputTitle={scheduletext.outeventvalue}
                          textInput={outeventvalue}
                          handleTextInputChange={handleOuteventvalueChange}
                          disabled={!mbm_geb_control_schedules}
                        />
                      </div>
                    </>
            }
            {/* <div>
              <TextInput
                inputTitle={scheduletext.eventvalue}
                textInput={eventvalue}
                handleTextInputChange={handleEventvalueChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
            <div>
              <TextInput
                inputTitle={scheduletext.outeventvalue}
                textInput={outeventvalue}
                handleTextInputChange={handleOuteventvalueChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div> */}
          </TabPanel>
        </div>
        {mbm_geb_control_schedules ?
          <Button
            disabled={buttonDisabled}
            className={
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
            }
            onClick={() => {
              handleSubmit();
            }}
          >
            Enregistrer
          </Button> : <></>
        }
      </TabContext>
      <Dialog
        onClose={handleEditCloseDefaultWeekEvent}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openDefaultWeekEvent}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseDefaultWeekEvent}>
          Evènement
        </CustomDialogTitle>
        <DialogContent dividers>
          <DefaultWeekEventDialog
            closeModal={handleEditCloseDefaultWeekEvent}
            editedevent={editedevent}
            scheduletype={type}
            controltype={controltype}
            availablemodes={availablemodes}
            existingevents={defaultweekevents}
            setExistingevents={setDefaultweekevents}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditCloseCalendarEvent}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openCalendarEvent}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseCalendarEvent}>
          Evènement
        </CustomDialogTitle>
        <DialogContent dividers>
          <CalendarEventDialog
            closeModal={handleEditCloseCalendarEvent}
            editedevent={editedevent}
            scheduletype={type}
            controltype={controltype}
            availablemodes={availablemodes}
            existingevents={calendarevents}
            setExistingevents={setCalendarevents}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <CustomConfirmationDialog
        open={typechangeopen}
        dialogContent={scheduletext.changetypeconfirmationtext}
        handleExit={applyChangeType}
        handleClose={denyChangeType}
      />
      <CustomConfirmationDialog
        open={equipmenttypechangeopen}
        dialogContent={scheduletext.changeequipmenttypeconfirmationtext}
        handleExit={applyChangeEquipmentType}
        handleClose={denyChangeEquipmentType}
      />
      <CustomConfirmationDialog
        open={controltypechangeopen}
        dialogContent={scheduletext.changecontroltypeconfirmationtext}
        handleExit={applyChangeControlType}
        handleClose={denyChangeControlType}
      />
    </>
  );
}

export default ScheduleDialog;
